// extracted by mini-css-extract-plugin
export default {"wrapper":"ConstructorNavComponent_wrapper__mo1II","item_nav_active":"ConstructorNavComponent_item_nav_active__MqqAn","item_nav":"ConstructorNavComponent_item_nav__M5+iH"};